import { CodeBook, ExportTypeEnum, PagedResult } from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils";

import { ProfessionType} from "../../models/Profession";
import { Profession } from "../../models/Profession/Profession";
import { EditProfessionRequest } from "./EditProfessionRequest";
import { SearchProfessionRequest } from "./SearchProfessionRequest";

const professionsUrlPrefix: string = "professions";

export const searchProfessionsCodeBook = async (search: string, typeId: ProfessionType) => {
  return api.get(
      `${professionsUrlPrefix}?search=${search}&typeId=${typeId}`
  ) as Promise<CodeBook[]>
}

export const searchProfessions = async (request: SearchProfessionRequest) => {
  let result = await api.get(
      `${professionsUrlPrefix}/search`,
      request
  ) as PagedResult<Profession>;
  return result;
}

export const getProfessionById = async (id: number) => {
    let result = await api.get(
        `${professionsUrlPrefix}/${id}`
    ) as Profession;
    return result;
}

export const editProfession = async (id: number, request: EditProfessionRequest) => {
  return api.put(
      `${professionsUrlPrefix}/${id}`,
      request
  ) as Promise<void>
}

export const exportProfessions = async (exportType: ExportTypeEnum) => {
  var result = await (api.download(
    `${professionsUrlPrefix}/export/${exportType}`,
    "get"
  ) as Promise<unknown>);
  return result
}
